import { Divider as ChDivider, DividerProps } from '@chakra-ui/react'

export const Divider = (props: DividerProps) => (
  <ChDivider
    borderBottomWidth={1}
    borderBottomStyle="solid"
    borderBottomColor="gray"
    {...props}
  />
)
